import React from "react";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";

import { NEWSLETTER_PACKAGES } from "shared/data/newsletter";

import { Container, SubTitle, Title } from "./styles";

type Props = {
  className?: string;
};

export const TitleDisplay: React.FunctionComponent<Props> = ({ className }) => {
  const { packageDisplayName = "", packageKey } = useNewsletterContext();

  const targetNewsletterPackage = packageKey ? NEWSLETTER_PACKAGES[packageKey] : null;
  const isBundle = (targetNewsletterPackage?.childNewsletterIds ?? []).length > 1;

  return (
    <Container className={className}>
      <Title>NEWSLETTER {isBundle && "BUNDLE"}</Title>
      <SubTitle>{packageDisplayName}</SubTitle>
    </Container>
  );
};

TitleDisplay.displayName = "TitleDisplay";
